<div class="progress-loader" [hidden]="!loading">
  <mat-progress-bar [mode]="'indeterminate'" color="accent"> </mat-progress-bar>
  <mat-progress-spinner [mode]="'indeterminate'"> </mat-progress-spinner>
</div>
